import { Box } from "@mui/material";
import React from "react";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { useDialog } from "../../../../hooks/useDialog";
import { CustomSection } from "../CustomSection";
import { InfoBox } from "../InfoBox";
import { LogisticaDialog } from "../LogisticaDialog";

export function ContratoSection({ formValues, idEvaluacion, data }) {
  const { isDialogOpen, handleOpenDialog, handleCloseDialog } = useDialog();

  return (
    <>
      <CustomSection title="Contrato">
        <Box
          sx={{
            display: "grid",
            gap: "30px",
            gridTemplateColumns: { lg: "repeat(4, 1fr)", md: "repeat(2, 1fr)" },
          }}
        >
          <InfoBox
            label="Fecha de evaluación"
            value={formValues.fechaEvaluacion}
          />
          <InfoBox
            label="Cnx. semanales"
            value={formValues.conexionesSemanales}
          />
          <InfoBox label="Plan" value={formValues.planCuidado} />
          <CustomButton
            label="Mostrar logistica"
            variant="outlined"
            onClick={handleOpenDialog}
          />
        </Box>
      </CustomSection>

      {isDialogOpen && (
        <LogisticaDialog
          open={isDialogOpen}
          handleCloseDialog={handleCloseDialog}
          idEvaluacion={idEvaluacion}
          data={data?.envio?.cabecera}
        />
      )}
    </>
  );
}
